
// 默认菜单初始化配置
export class DefaultMenuOption {
    constructor() {
        this.pay = true
        this.hottop = true
        this.promote = true // 此版本暂不使用
        this.home = true
        this.setting = true // 此版本弃用
        this.em = true
        this.sharpflat = true
        this.vocals = true
        this.help = true
        this.about = true
        this.logout = true
    }
}
// 默认页面配置
export class DefaultPageset {
    constructor() {
        this.em = true
        this.emBackup = true
        this.aiEm = true
        this.emSharp = false
        this.emModel = false
        this.player = true
        this.vocals = true
        this.sharpFlat = true
        this.emRate = true
        this.emHumanize = false
        this.emFlex = false
        this.linkage = false
        this.shortcut = false
        this.emFineTune = true
        this.emVibrato = false
        this.emTracking = false
        this.emLinkage = false
    }
}
// 默认快捷键关联
export class DefaultShortcutLink {
    constructor() {
        this.rate = true
        this.flex = true
        this.humanize = true
        this.vibrato = true
        this.tracking = true
    }
}
// 默认电音参数快捷选项
export class DefautlShortcut {
    constructor() {
        this.pre1 = {
            name: '修音',
            rate: 43,
            humanize: 60,
            vibrato: 0,
            flex: 0,
            tracking: 19,
        }
        this.pre2 = {
            name: '常用',
            rate: 23,
            humanize: 51,
            vibrato: 1,
            flex: 27,
            tracking: 50,
        }
        this.pre3 = {
            name: '电音',
            rate: 10,
            humanize: 48,
            vibrato: 1.2,
            flex: 29,
            tracking: 5,
        }
    }
}
// 默认电音模式的快捷键关联选项
export class DefaultEmModelShortcut {
    constructor() {
        this.soprano = {
            pre1: {
                name: '女修音',
                rate: 44,
                humanize: 88,
                vibrato: -1.2,
                flex: 0,
                tracking: 10,
            },
            pre2: {
                name: '女微电',
                rate: 23,
                humanize: 88,
                vibrato: -1.2,
                flex: 28,
                tracking: 10,
            },
            pre3: {
                name: '女强电',
                rate: 16,
                humanize: 88,
                vibrato: -1.2,
                flex: 0,
                tracking: 10,
            }
        }
        this.alto = {
            pre1: {
                name: '中修音',
                rate: 42,
                humanize: 50,
                vibrato: 1.2,
                flex: 0,
                tracking: 12,
            },
            pre2: {
                name: '中微电',
                rate: 19,
                humanize: 50,
                vibrato: 1.2,
                flex: 28,
                tracking: 5,
            },
            pre3: {
                name: '中强电',
                rate: 5,
                humanize: 50,
                vibrato: 1.2,
                flex: 28,
                tracking: 5,
            }
        }
        this.lowMale = {
            pre1: {
                name: '男修音',
                rate: 42,
                humanize: 75,
                vibrato: 1,
                flex: 1,
                tracking: 11,
            },
            pre2: {
                name: '男微电',
                rate: 20,
                humanize: 50,
                vibrato: 1.2,
                flex: 28,
                tracking: 25,
            },
            pre3: {
                name: '男强电',
                rate: 5,
                humanize: 50,
                vibrato: 1.2,
                flex: 28,
                tracking: 25,
            }
        }
    }
}
// 速率配置（面板上叫「强度」，用户更好理解）
export class Rate {
    constructor() {
        this.name = '强度'
        this.isInit = true
        this.value = 28
        this.pre1 = {
            name: '女修音',
            value: 45
        }
        this.pre2 = {
            name: '男修音',
            value: 34
        }
        this.pre3 = {
            name: '女电音',
            value: 20
        }
        this.pre4 = {
            name: '男电音',
            value: 15
        }
    }
}
// 拟人配置
export class Humanize {
    constructor() {
        this.name = '拟人'
        this.isInit = false
        this.value = 51
        this.pre1 = {
            name: '女修音',
            value: 89
        }
        this.pre2 = {
            name: '男修音',
            value: 65
        }
        this.pre3 = {
            name: '女电音',
            value: 55
        }
        this.pre4 = {
            name: '男电音',
            value: 45
        }
    }
}
// 颤音配置
export class Vibrato {
    constructor() {
        this.name = '颤音'
        this.isInit = false
        this.value = 1
        this.pre1 = {
            name: '女修音',
            value: -1
        }
        this.pre2 = {
            name: '男修音',
            value: 0.9
        }
        this.pre3 = {
            name: '女电音',
            value: 1.1
        }
        this.pre4 = {
            name: '男电音',
            value: 1.3
        }
    }
}
// 弹性配置
export class Flex {
    constructor() {
        this.name = '弹性'
        this.isInit = true
        this.value = 27
        this.pre1 = {
            name: '女修音',
            value: 0
        }
        this.pre2 = {
            name: '男修音',
            value: 2
        }
        this.pre3 = {
            name: '女电音',
            value: 25
        }
        this.pre4 = {
            name: '男电音',
            value: 29
        }
    }
}
// 跟踪配置
export class Tracking {
    constructor() {
        this.name = '跟踪'
        this.isInit = false
        this.value = 13
        this.pre1 = {
            name: '女修音',
            value: 14
        }
        this.pre2 = {
            name: '男修音',
            value: 12
        }
        this.pre3 = {
            name: '女电音',
            value: 9
        }
        this.pre4 = {
            name: '男电音',
            value: 22
        }
    }
}
// 联动调节配置
export class EmLinkage {
    constructor() {
        this.rate = {
            isLink: true,
            start: 70,
            end: 0,
        }
        this.humanize = {
            isLink: true,
            start: 90,
            end: 40,
        }
        this.vibrato = {
            isLink: true,
            start: -1.2,
            end: 2,
        }
        this.flex = {
            isLink: true,
            start: 0,
            end: 55,
        }
        this.tracking = {
            isLink: true,
            start: 50,
            end: 10,
        }
    }
}
// 个性化配置
export class UiExtConf {
    constructor() {
        this.version = "3.9.7"
        this.isTop = false
        this.valueShowModel = 'pluginvalue'
        this.pageset = {
            em: {
                name: '首推基调',
                show: true
            },
            emBackup: {
                name: '备选基调',
                show: true
            },
            aiEm: {
                name: 'Ai 基调',
                show: true
            },
            emSharp: {
                name: '手动修订',
                show: false
            },
            emModel: {
                name: '模式选择',
                show: false
            },
            player: {
                name: '播放器',
                show: true
            },
            vocals: {
                name: '原声消除',
                show: true
            },
            sharpFlat: {
                name: '伴奏升降',
                show: true
            },
            emRate: {
                name: '强度',
                show: true
            },
            emHumanize: {
                name: '拟人',
                show: false
            },
            emFlex: {
                name: '弹性',
                show: false
            },
            linkage: {
                name: '联动调节',
                show: false
            },
            shortcut: {
                name: '快捷切换',
                show: false
            },
            emFineTune: {
                name: '电音精调',
                show: true
            },
            emVibrato: {
                name: '颤音',
                show: false
            },
            emTracking: {
                name: '跟踪',
                show: false
            },
            emLinkage: {
                name: '联动调节',
                show: false
            }
        }
        this.rate = new Rate()
        this.flex = new Flex()
        this.humanize = new Humanize()
        this.vibrato = new Vibrato()
        this.tracking = new Tracking()
        this.linkage = {
            value: 50,
            isLinkRate: true,
            isLinkFlex: true,
            isLinkHumanize: false
        }
        this.shortcut = new DefautlShortcut()
        this.shortcutLink = new DefaultShortcutLink()
        this.isSetShortcutByEmModel = false
        this.emModelShortcut = new DefaultEmModelShortcut()
        this.emLinkage = new EmLinkage()
    }
}

// 电音参数范围
export class EmValueRange {
    constructor() {
        this.rate = {
            min: 0,
            max: 400,
            step: 1
        }
        this.flex = {
            min: 0,
            max: 100,
            step: 1
        }
        this.humanize = {
            min: 0,
            max: 100,
            step: 1
        }
        this.vibrato = {
            min: -12,
            max: 12,
            step: 0.1
        }
        this.tracking = {
            min: 1,
            max: 100,
            step: 1
        }
    }
}
// 电音参数选项
export const EmValueSelect = [{
    name: "强度",
    value: "rate",
    plugName: "Retune Speed",
    range: "400~0"
}, {
    name: "拟人",
    value: "humanize",
    plugName: "Humanize",
    range: "0~100"
}, {
    name: "颤音",
    value: "vibrato",
    plugName: "Natural Vibrato",
    range: "-12~+12"
}, {
    name: "弹性",
    value: "flex",
    plugName: "Flex Tune",
    range: "0~100"
}, {
    name: "跟踪",
    value: "tracking",
    plugName: "Tracking",
    range: "100~1"
}]

// 播放器列表
export const playerList = [{
    player: 'kugou',
    name: '酷狗音乐',
    processName: 'KuGou.exe'
}, {
    player: 'qq',
    name: 'QQ音乐',
    processName: 'QQMusic.exe'
}, {
    player: 'kuwo',
    name: '酷我音乐',
    processName: 'kwmusic.exe'
}, {
    player: 'netease',
    name: '网易云音乐',
    processName: 'cloudmusic.exe'
}, {
    player: 'soda',
    name: '汽水音乐',
    processName: 'SodaMusic.exe'
}, {
    player: 'wesing',
    name: '全民K歌',
    processName: 'WeSing.exe'
}, {
    player: 'baidu',
    name: '百度音乐',
    processName: 'BaiduMusic.exe'
}, {
    player: 'xiami',
    name: '虾米音乐',
    processName: 'XiamiPC.exe'
}, {
    player: 'fanxing',
    name: '繁星伴侣',
    processName: 'FanXingBanZou.exe'
}, {
    player: 'mvbox',
    name: 'MvBox',
    processName: 'MvBoxPlayer.exe'
}, {
    player: 'foobar',
    name: 'Foobar',
    processName: 'foobar2000.exe'
}]

// 插件配置
// export const pluginConfig = [{
//     name: 'Auto-Tune VST2',
//     matchName: ['电音5', '电音6'],
// }, {
//     name: 'Auto-Tune VST3',
//     matchName: ['Auto-Tune Artist', '电音9 Pro', '电音10 Pro', 'Auto-Tune EFX', 'Auto-Tune Access', '电音 8.1'],
// }, {
//     name: 'Waves-Tune VST3',
//     matchName: ['紫色电音'],
// }, {
//     name: 'iZotope T-Pain Effect',
//     matchName: ['臭氧'],
// }, {
//     name: '弯音轮 VST2',
//     matchName: ['升降调'],
// }, {
//     name: '弯音轮 VST3',
//     matchName: ['升降调vst3'],
// }, {
//     name: 'Pitch Monster VST3',
//     matchName: ['升降调PitchMonster'],
// }, {
//     name: 'Waves SoundShifter VST3',
//     matchName: ['waves升降调vst3'],
// }, {
//     name: 'Remix VST2',
//     matchName: ['消人声'],
// }, {
//     name: 'Remix VST3',
//     matchName: [],
// }]
export const pluginConfig = [{
        name: '弯音轮（单） VST2',
        matchName: ['升降调'],
    }, {
        name: 'kHs PitchShifter VST2',
        matchName: ['升降调kHs'],
    }, {
        name: 'Remix VST2',
        matchName: ['消人声'],
    }, {
        name: 'Auto-Tune VST2',
        matchName: ['电音4', '电音5'],
    }, {
        name: 'Auto-Tune EVO',
        matchName: ['电音6'],
    }, {
        name: 'iZotope T-Pain Effect',
        matchName: ['臭氧'],
    }, {
        name: 'Waves-Tune  VST3',
        matchName: ['紫色电音'],
    }, {
        name: 'Waves SoundShifter',
        matchName: ['waves升降调vst3'],
    }, {
        name: '和声-Harmony VST3',
        matchName: ['Harmony'],
    }, {
        name: 'Auto-Tune Artist',
        matchName: ['Auto-Tune Artist'],
    }, {
        name: 'Auto-Tune 9',
        matchName: ['电音9 Pro'],
    }, {
        name: 'Auto-Tune Pro',
        matchName: ['电音10 Pro'],
    }, {
        name: 'Auto-Tune EFX',
        matchName: ['Auto-Tune EFX'],
    }, {
        name: 'Auto-Tune Access',
        matchName: ['Auto-Tune Access'],
    }, {
        name: 'Auto-Tune 8.1',
        matchName: ['电音 8.1'],
    }, {
        name: '弯音轮（单） VST3',
        matchName: ['升降调vst3'],
    }, {
        name: 'PitchMonster VST3',
        matchName: ['升降调PitchMonster'],
    }, {
        name: 'kHs PitchShifter VST3',
        matchName: ['升降调kHsPitchShifter'],
    }, {
        name: 'Inner Pitch VST3',
        matchName: ['升降调Inner Pitch'],
    }, {
        name: 'Nuro Audio X-Pitch',
        matchName: ['xpitch'],
    }, {
        name: 'Safari Audio Vocal-Tune',
        matchName: ['Vocal Tune'],
    }
    // 下面的暂未启用
    , {
        name: 'Remix VST3',
        matchName: ['消人声vst3'],
    }, {
        name: 'PitchMonster VST2',
        matchName: ['升降调PitchMonsterVST2'],
    }, {
        name: 'Inner Pitch VST2',
        matchName: ['升降调Inner PitchVST2'],
    }
]

// 基调配置
export const keynoteConfig = [{
    ketnote: 'C',
    matchValue: ['C']
}, {
    ketnote: 'Db',
    matchValue: ['Db', 'C#']
}, {
    ketnote: 'D',
    matchValue: ['D']
}, {
    ketnote: 'Eb',
    matchValue: ['Eb', 'D#']
}, {
    ketnote: 'E',
    matchValue: ['E']
}, {
    ketnote: 'F',
    matchValue: ['F']
}, {
    ketnote: 'F#',
    matchValue: ['F#', 'Gb']
}, {
    ketnote: 'G',
    matchValue: ['G']
}, {
    ketnote: 'Ab',
    matchValue: ['Ab', 'G#']
}, {
    ketnote: 'A',
    matchValue: ['A']
}, {
    ketnote: 'Bb',
    matchValue: ['Bb', 'A#']
}, {
    ketnote: 'B',
    matchValue: ['B']
}]

// 基调备选被指
export const givenKeynoteBackup = [{
    major: ["C"],
    minor: ["A"]
}, {
    major: ["C#", "Db"],
    minor: ["Bb", "A#"]
}, {
    major: ["D"],
    minor: ["B"]
}, {
    major: ["Eb"],
    minor: ["C"]
}, {
    major: ["E"],
    minor: ["C#"]
}, {
    major: ["F"],
    minor: ["D"]
}, {
    major: ["F#", "Gb"],
    minor: ["Eb", "D#"]
}, {
    major: ["G"],
    minor: ["E"]
}, {
    major: ["Ab"],
    minor: ["F"]
}, {
    major: ["A"],
    minor: ["F#"]
}, {
    major: ["Bb"],
    minor: ["G"]
}, {
    major: ["B", "Cb"],
    minor: ["Ab", "G#"]
}]

// AIEM
//	INVALID = 0,
//	C_MAJOR = 1,
//	D_FLAT_MAJOR = 2,
//	D_MAJOR = 3,
//	E_FLAT_MAJOR = 4,
//	E_MAJOR = 5,
//	F_MAJOR = 6,
//	F_SHARP_MAJOR = 7, // Same as G_FLAT_MAJOR
//	G_MAJOR = 8,
//	A_FLAT_MAJOR = 9,
//	A_MAJOR = 10,
//	B_FLAT_MAJOR = 11,
//	B_MAJOR = 12,
//	C_MINOR = 13,
//	C_SHARP_MINOR = 14,
//	D_MINOR = 15,
//	E_FLAT_MINOR = 16, // Same as D_SHARP_MINOR
//	E_MINOR = 17,
//	F_MINOR = 18,
//	F_SHARP_MINOR = 19,
//	G_MINOR = 20,
//	G_SHARP_MINOR = 21,
//	A_MINOR = 22,
//	B_FLAT_MINOR = 23,
//	B_MINOR = 24,
export const AiEmList = [{
    index: 1,
    type: "EM_KN_AI",
    musicKeynote: "C Major(大调)",
    newKeyNote: "C",
    newScale: "大调",
    isMinor: false,
    color: "#F8FF5F",
}, {
    index: 2,
    type: "EM_KN_AI",
    musicKeynote: "Db Major(大调)",
    newKeyNote: "Db",
    newScale: "大调",
    isMinor: false,
    color: "#99FFFF",
}, {
    index: 3,
    type: "EM_KN_AI",
    musicKeynote: "D Major(大调)",
    newKeyNote: "D",
    newScale: "大调",
    isMinor: false,
    color: "#33CC99",
}, {
    index: 4,
    type: "EM_KN_AI",
    musicKeynote: "Eb Major(大调)",
    newKeyNote: "Eb",
    newScale: "大调",
    isMinor: false,
    color: "#00EFFF",
}, {
    index: 5,
    type: "EM_KN_AI",
    musicKeynote: "E Major(大调)",
    newKeyNote: "E",
    newScale: "大调",
    isMinor: false,
    color: "#CCCCFF",
}, {
    index: 6,
    type: "EM_KN_AI",
    musicKeynote: "F Major(大调)",
    newKeyNote: "F",
    newScale: "大调",
    isMinor: false,
    color: "#9966FF",
}, {
    index: 7,
    type: "EM_KN_AI",
    musicKeynote: "F# Major(大调)",
    newKeyNote: "F#",
    newScale: "大调",
    isMinor: false,
    color: "#E6AADD",
}, {
    index: 8,
    type: "EM_KN_AI",
    musicKeynote: "G Major(大调)",
    newKeyNote: "G",
    newScale: "大调",
    isMinor: false,
    color: "#6699FF",
}, {
    index: 9,
    type: "EM_KN_AI",
    musicKeynote: "Ab Major(大调)",
    newKeyNote: "Ab",
    newScale: "大调",
    isMinor: false,
    color: "#00ADE7",
}, {
    index: 10,
    type: "EM_KN_AI",
    musicKeynote: "A Major(大调)",
    newKeyNote: "A",
    newScale: "大调",
    isMinor: false,
    color: "#33CC33",
}, {
    index: 11,
    type: "EM_KN_AI",
    musicKeynote: "Bb Major(大调)",
    newKeyNote: "Bb",
    newScale: "大调",
    isMinor: false,
    color: "#FF6673",
}, {
    index: 12,
    type: "EM_KN_AI",
    musicKeynote: "B Major(大调)",
    newKeyNote: "B",
    newScale: "大调",
    isMinor: false,
    color: "#FF0000",
}, {
    index: 13,
    type: "EM_KN_AI",
    musicKeynote: "C Minor(小调)",
    newKeyNote: "C",
    newScale: "小调",
    isMinor: true,
    color: "#FF70C1",
}, {
    index: 14,
    type: "EM_KN_AI",
    musicKeynote: "C# Minor(小调)",
    newKeyNote: "C#",
    newScale: "小调",
    isMinor: true,
    color: "#00ADFF",
}, {
    index: 15,
    type: "EM_KN_AI",
    musicKeynote: "D Minor(小调)",
    newKeyNote: "D",
    newScale: "小调",
    isMinor: true,
    color: "#FF00FF",
}, {
    index: 16,
    type: "EM_KN_AI",
    musicKeynote: "Eb Minor(小调)",
    newKeyNote: "Eb",
    newScale: "小调",
    isMinor: true,
    color: "#CE95FF",
}, {
    index: 17,
    type: "EM_KN_AI",
    musicKeynote: "E Minor(小调)",
    newKeyNote: "E",
    newScale: "小调",
    isMinor: true,
    color: "#FFF500",
}, {
    index: 18,
    type: "EM_KN_AI",
    musicKeynote: "F Minor(小调)",
    newKeyNote: "F",
    newScale: "小调",
    isMinor: true,
    color: "#00FF00",
}, {
    index: 19,
    type: "EM_KN_AI",
    musicKeynote: "F# Minor(小调)",
    newKeyNote: "F#",
    newScale: "小调",
    isMinor: true,
    color: "#A4FF89",
}, {
    index: 20,
    type: "EM_KN_AI",
    musicKeynote: "G Minor(小调)",
    newKeyNote: "G",
    newScale: "小调",
    isMinor: true,
    color: "#FAFFB7",
}, {
    index: 21,
    type: "EM_KN_AI",
    musicKeynote: "G# Minor(小调)",
    newKeyNote: "G#",
    newScale: "小调",
    isMinor: true,
    color: "#FFC8C8",
}, {
    index: 22,
    type: "EM_KN_AI",
    musicKeynote: "A Minor(小调)",
    newKeyNote: "A",
    newScale: "小调",
    isMinor: true,
    color: "#009933",
}, {
    index: 23,
    type: "EM_KN_AI",
    musicKeynote: "Bb Minor(小调)",
    newKeyNote: "Bb",
    newScale: "小调",
    isMinor: true,
    color: "#6699FF",
}, {
    index: 24,
    type: "EM_KN_AI",
    musicKeynote: "B Minor(小调)",
    newKeyNote: "B",
    newScale: "小调",
    isMinor: true,
    color: "#FF6600",
}]

// 电音速率配置
export const emRateConfig = [
    1, 0.97088, 0.944727, 0.920992, 0.899265, 0.879233, 0.86065, 0.843321, 0.827087, 0.811819,
    0.797407, 0.78376, 0.770802, 0.758466, 0.746695, 0.73544, 0.724657, 0.714309, 0.704361, 0.694785,
    0.685552, 0.676639, 0.668026, 0.659692, 0.651619, 0.643793, 0.636198, 0.628821, 0.62165, 0.614673,
    0.607881, 0.601264, 0.594813, 0.58852, 0.582378, 0.576379, 0.570516, 0.564785, 0.559178, 0.553692,
    0.54832, 0.543058, 0.537902, 0.532847, 0.527889, 0.523026, 0.518253, 0.513566, 0.508964, 0.504443,
    0.5, 0.495632, 0.491338, 0.487114, 0.482958, 0.478869, 0.474844, 0.47088, 0.466977, 0.463133, 0.459344,
    0.455611, 0.451932, 0.448304, 0.444727, 0.441199, 0.437719, 0.434285, 0.430897, 0.427553, 0.424251,
    0.420992, 0.417773, 0.414595, 0.411455, 0.408353, 0.405288, 0.402259, 0.399265, 0.396306, 0.393381,
    0.390488, 0.387628, 0.384799, 0.382001, 0.379233, 0.376495, 0.373785, 0.371104, 0.36845, 0.365824,
    0.363224, 0.36065, 0.358102, 0.355579, 0.35308, 0.350605, 0.348154, 0.345726, 0.343321, 0.340938,
    0.338577, 0.336238, 0.33392, 0.331622, 0.329345, 0.327087, 0.32485, 0.322632, 0.320432, 0.318252,
    0.316089, 0.313945, 0.311819, 0.30971, 0.307618, 0.305543, 0.303484, 0.301442, 0.299417, 0.297407,
    0.295412, 0.293433, 0.291469, 0.28952, 0.287586, 0.285666, 0.28376, 0.281868, 0.279991, 0.278126,
    0.276276, 0.274438, 0.272613, 0.270802, 0.269003, 0.267216, 0.265442, 0.26368, 0.26193, 0.260192,
    0.258466, 0.256751, 0.255047, 0.253355, 0.251674, 0.250004, 0.248344, 0.246695, 0.245057, 0.243429,
    0.241811, 0.240203, 0.238606, 0.237018, 0.23544, 0.233872, 0.232313, 0.230763, 0.229223, 0.227692,
    0.22617, 0.224657, 0.223153, 0.221658, 0.220171, 0.218693, 0.217224, 0.215762, 0.214309, 0.212864,
    0.211427, 0.209999, 0.208578, 0.207165, 0.205759, 0.204361, 0.202971, 0.201589, 0.200213, 0.198845,
    0.197485, 0.196131, 0.194785, 0.193445, 0.192113, 0.190787, 0.189468, 0.188156, 0.186851, 0.185552,
    0.18426, 0.182974, 0.181694, 0.180421, 0.179155, 0.177894, 0.176639, 0.175391, 0.174149, 0.172913,
    0.171682, 0.170458, 0.169239, 0.168026, 0.166819, 0.165617, 0.164421, 0.16323, 0.162045, 0.160866,
    0.159692, 0.158523, 0.157359, 0.156201, 0.155048, 0.1539, 0.152757, 0.151619, 0.150487, 0.149359,
    0.148236, 0.147118, 0.146005, 0.144896, 0.143793, 0.142694, 0.1416, 0.14051, 0.139425, 0.138345,
    0.137269, 0.136198, 0.135131, 0.134068, 0.13301, 0.131956, 0.130907, 0.129862, 0.128821, 0.127784,
    0.126751, 0.125723, 0.124698, 0.123678, 0.122662, 0.12165, 0.120641, 0.119637, 0.118636, 0.11764,
    0.116647, 0.115658, 0.114673, 0.113692, 0.112714, 0.11174, 0.11077, 0.109803, 0.10884, 0.107881,
    0.106925, 0.105973, 0.105024, 0.104079, 0.103137, 0.102199, 0.101264, 0.100332, 0.099404, 0.098479,
    0.097558, 0.09664, 0.095725, 0.094813, 0.093905, 0.092999, 0.092097, 0.091198, 0.090302, 0.08941,
    0.08852, 0.087634, 0.08675, 0.08587, 0.084992, 0.084118, 0.083246, 0.082378, 0.081512, 0.080649,
    0.079789, 0.078932, 0.078078, 0.077227, 0.076379, 0.075533, 0.07469, 0.07385, 0.073012, 0.072178,
    0.071346, 0.070516, 0.06969, 0.068866, 0.068044, 0.067226, 0.066409, 0.065596, 0.064785, 0.063976,
    0.063171, 0.062367, 0.061566, 0.060768, 0.059972, 0.059178, 0.058387, 0.057599, 0.056813, 0.056029,
    0.055248, 0.054468, 0.053692, 0.052917, 0.052145, 0.051376, 0.050608, 0.049843, 0.04908, 0.04832,
    0.047562, 0.046805, 0.046052, 0.0453, 0.04455, 0.043803, 0.043058, 0.042315, 0.041574, 0.040835,
    0.040099, 0.039364, 0.038632, 0.037902, 0.037173, 0.036447, 0.035723, 0.035001, 0.034281, 0.033563,
    0.032847, 0.032133, 0.03142, 0.03071, 0.030002, 0.029296, 0.028592, 0.027889, 0.027189, 0.02649,
    0.025794, 0.025099, 0.024406, 0.023715, 0.023026, 0.022338, 0.021653, 0.020969, 0.020287, 0.019607,
    0.018929, 0.018253, 0.017578, 0.016905, 0.016234, 0.015564, 0.014897, 0.014231, 0.013566, 0.012904,
    0.012243, 0.011584, 0.010927, 0.010271, 0.009617, 0.008964, 0.008313, 0.007664, 0.007017, 0.006371,
    0.005727, 0.005084, 0.004443, 0.003804, 0.003166, 0.002529, 0.001895, 0.001262, 0.00063, 0
]

// wave电音速率配置
export const wavesEmRateConfig = [0, 0.009018, 0.019038, 0.029058, 0.039078, 0.049098, 0.059118, 0.069138, 0.079158, 0.089178,
    0.099198, 0.109218, 0.119238, 0.129259, 0.139279, 0.149299, 0.159319, 0.169339, 0.179359, 0.189379, 0.199399,
    0.209419, 0.219439, 0.229459, 0.239479, 0.249499, 0.259519, 0.269539, 0.279559, 0.289579, 0.299599, 0.309619,
    0.319639, 0.329659, 0.339679, 0.349699, 0.359719, 0.369739, 0.37976, 0.38978, 0.3998, 0.40982, 0.41984, 0.42986,
    0.43988, 0.4499, 0.45992, 0.46994, 0.47996, 0.48998, 0.5, 0.502371, 0.504743, 0.507114, 0.509486, 0.511857, 0.514229,
    0.5166, 0.518971, 0.521343, 0.523714, 0.526086, 0.528457, 0.530829, 0.5332, 0.535571, 0.537943, 0.540314, 0.542686,
    0.545057, 0.547429, 0.5498, 0.552171, 0.554543, 0.556914, 0.559286, 0.561657, 0.564029, 0.5664, 0.568771, 0.571143,
    0.573514, 0.575886, 0.578257, 0.580629, 0.583, 0.585371, 0.587743, 0.590114, 0.592486, 0.594857, 0.597229, 0.5996,
    0.601971, 0.604343, 0.606714, 0.609086, 0.611457, 0.613829, 0.6162, 0.618571, 0.620943, 0.623314, 0.625686, 0.628057,
    0.630429, 0.6328, 0.635171, 0.637543, 0.639914, 0.642286, 0.644657, 0.647029, 0.6494, 0.651771, 0.654143, 0.656514,
    0.658886, 0.661257, 0.663629, 0.666, 0.666491, 0.666982, 0.667474, 0.667965, 0.668456, 0.668947, 0.669438, 0.669929,
    0.670421, 0.670912, 0.671403, 0.671894, 0.672385, 0.672876, 0.673368, 0.673859, 0.67435, 0.674841, 0.675332, 0.675824,
    0.676315, 0.676806, 0.677297, 0.677788, 0.678279, 0.678771, 0.679262, 0.679753, 0.680244, 0.680735, 0.681226, 0.681718,
    0.682209, 0.6827, 0.683191, 0.683682, 0.684174, 0.684665, 0.685156, 0.685647, 0.686138, 0.686629, 0.687121, 0.687612,
    0.688103, 0.688594, 0.689085, 0.689576, 0.690068, 0.690559, 0.69105, 0.691541, 0.692032, 0.692524, 0.693015, 0.693506,
    0.693997, 0.694488, 0.694979, 0.695471, 0.695962, 0.696453, 0.696944, 0.697435, 0.697926, 0.698418, 0.698909, 0.6994,
    0.699891, 0.700382, 0.700874, 0.701365, 0.701856, 0.702347, 0.702838, 0.703329, 0.703821, 0.704312, 0.704803, 0.705294,
    0.705785, 0.706276, 0.706768, 0.707259, 0.70775, 0.708241, 0.708732, 0.709224, 0.709715, 0.710206, 0.710697, 0.711188,
    0.711679, 0.712171, 0.712662, 0.713153, 0.713644, 0.714135, 0.714626, 0.715118, 0.715609, 0.7161, 0.716591, 0.717082,
    0.717574, 0.718065, 0.718556, 0.719047, 0.719538, 0.720029, 0.720521, 0.721012, 0.721503, 0.721994, 0.722485, 0.722976,
    0.723468, 0.723959, 0.72445, 0.724941, 0.725432, 0.725924, 0.726415, 0.726906, 0.727397, 0.727888, 0.728379, 0.728871,
    0.729362, 0.729853, 0.730344, 0.730835, 0.731326, 0.731818, 0.732309, 0.7328, 0.733291, 0.733782, 0.734274, 0.734765,
    0.735256, 0.735747, 0.736238, 0.736729, 0.737221, 0.737712, 0.738203, 0.738694, 0.739185, 0.739676, 0.740168, 0.740659,
    0.74115, 0.741641, 0.742132, 0.742624, 0.743115, 0.743606, 0.744097, 0.744588, 0.745079, 0.745571, 0.746062, 0.746553,
    0.747044, 0.747535, 0.748026, 0.748518, 0.749009, 0.7495, 0.749991, 0.750482, 0.750974, 0.751465, 0.751956, 0.752447,
    0.752938, 0.753429, 0.753921, 0.754412, 0.754903, 0.755394, 0.755885, 0.756376, 0.756868, 0.757359, 0.75785, 0.758341,
    0.758832, 0.759324, 0.759815, 0.760306, 0.760797, 0.761288, 0.761779, 0.762271, 0.762762, 0.763253, 0.763744, 0.764235,
    0.764726, 0.765218, 0.765709, 0.7662, 0.766691, 0.767182, 0.767674, 0.768165, 0.768656, 0.769147, 0.769638, 0.770129,
    0.770621, 0.771112, 0.771603, 0.772094, 0.772585, 0.773076, 0.773568, 0.774059, 0.77455, 0.775041, 0.775532, 0.776024,
    0.776515, 0.777006, 0.777497, 0.777988, 0.778479, 0.778971, 0.779462, 0.779953, 0.780444, 0.780935, 0.781426, 0.781918,
    0.782409, 0.7829, 0.783391, 0.783882, 0.784374, 0.784865, 0.785356, 0.785847, 0.786338, 0.786829, 0.787321, 0.787812,
    0.788303, 0.788794, 0.789285, 0.789776, 0.790268, 0.790759, 0.79125, 0.791741, 0.792232, 0.792724, 0.793215, 0.793706,
    0.794197, 0.794688, 0.795179, 0.795671, 0.796162, 0.796653, 0.797144, 0.797635, 0.798126, 0.798618, 0.799109, 0.7996,
    0.800091, 0.800582, 0.801074, 0.801565, 0.802056, 0.802547, 0.803038, 0.803529, 0.804021, 0.804512, 0.805003, 0.805494,
    0.805985, 0.806476, 0.806968, 0.807459, 0.80795, 0.808441, 0.808932, 0.809424, 0.809915, 0.810406, 0.810897, 0.811388,
    0.811879, 0.812371, 0.812862, 0.813353, 0.813844, 0.814335, 0.814826, 0.815318, 0.815809, 0.8163, 0.816791, 0.817282,
    0.817774, 0.818265, 0.818756, 0.819247, 0.819738, 0.820229, 0.820721, 0.821212, 0.821703, 0.822194, 0.822685, 0.823176,
    0.823668, 0.824159, 0.82465, 0.825141, 0.825632, 0.826124, 0.826615, 0.827106, 0.827597, 0.828088, 0.828579, 0.829071,
    0.829562, 0.830053, 0.830544, 0.831035, 0.831526, 0.832018, 0.832509, 0.833, 0.833491, 0.833982, 0.834474, 0.834965,
    0.835456, 0.835947, 0.836438, 0.836929, 0.837421, 0.837912, 0.838403, 0.838894, 0.839385, 0.839876, 0.840368, 0.840859,
    0.84135, 0.841841, 0.842332, 0.842824, 0.843315, 0.843806, 0.844297, 0.844788, 0.845279, 0.845771, 0.846262, 0.846753,
    0.847244, 0.847735, 0.848226, 0.848718, 0.849209, 0.8497, 0.850191, 0.850682, 0.851174, 0.851665, 0.852156, 0.852647,
    0.853138, 0.853629, 0.854121, 0.854612, 0.855103, 0.855594, 0.856085, 0.856576, 0.857068, 0.857559, 0.85805, 0.858541,
    0.859032, 0.859524, 0.860015, 0.860506, 0.860997, 0.861488, 0.861979, 0.862471, 0.862962, 0.863453, 0.863944, 0.864435,
    0.864926, 0.865418, 0.865909, 0.8664, 0.866891, 0.867382, 0.867874, 0.868365, 0.868856, 0.869347, 0.869838, 0.870329,
    0.870821, 0.871312, 0.871803, 0.872294, 0.872785, 0.873276, 0.873768, 0.874259, 0.87475, 0.875241, 0.875732, 0.876224,
    0.876715, 0.877206, 0.877697, 0.878188, 0.878679, 0.879171, 0.879662, 0.880153, 0.880644, 0.881135, 0.881626, 0.882118,
    0.882609, 0.8831, 0.883591, 0.884082, 0.884574, 0.885065, 0.885556, 0.886047, 0.886538, 0.887029, 0.887521, 0.888012,
    0.888503, 0.888994, 0.889485, 0.889976, 0.890468, 0.890959, 0.89145, 0.891941, 0.892432, 0.892924, 0.893415, 0.893906,
    0.894397, 0.894888, 0.895379, 0.895871, 0.896362, 0.896853, 0.897344, 0.897835, 0.898326, 0.898818, 0.899309, 0.8998,
    0.900291, 0.900782, 0.901274, 0.901765, 0.902256, 0.902747, 0.903238, 0.903729, 0.904221, 0.904712, 0.905203, 0.905694,
    0.906185, 0.906676, 0.907168, 0.907659, 0.90815, 0.908641, 0.909132, 0.909624, 0.910115, 0.910606, 0.911097, 0.911588,
    0.912079, 0.912571, 0.913062, 0.913553, 0.914044, 0.914535, 0.915026, 0.915518, 0.916009, 0.9165, 0.916991, 0.917482,
    0.917974, 0.918465, 0.918956, 0.919447, 0.919938, 0.920429, 0.920921, 0.921412, 0.921903, 0.922394, 0.922885, 0.923376,
    0.923868, 0.924359, 0.92485, 0.925341, 0.925832, 0.926324, 0.926815, 0.927306, 0.927797, 0.928288, 0.928779, 0.929271,
    0.929762, 0.930253, 0.930744, 0.931235, 0.931726, 0.932218, 0.932709, 0.9332, 0.933691, 0.934182, 0.934674, 0.935165,
    0.935656, 0.936147, 0.936638, 0.937129, 0.937621, 0.938112, 0.938603, 0.939094, 0.939585, 0.940076, 0.940568, 0.941059,
    0.94155, 0.942041, 0.942532, 0.943024, 0.943515, 0.944006, 0.944497, 0.944988, 0.945479, 0.945971, 0.946462, 0.946953,
    0.947444, 0.947935, 0.948426, 0.948918, 0.949409, 0.9499, 0.950391, 0.950882, 0.951374, 0.951865, 0.952356, 0.952847,
    0.953338, 0.953829, 0.954321, 0.954812, 0.955303, 0.955794, 0.956285, 0.956776, 0.957268, 0.957759, 0.95825, 0.958741,
    0.959232, 0.959724, 0.960215, 0.960706, 0.961197, 0.961688, 0.962179, 0.962671, 0.963162, 0.963653, 0.964144, 0.964635,
    0.965126, 0.965618, 0.966109, 0.9666, 0.967091, 0.967582, 0.968074, 0.968565, 0.969056, 0.969547, 0.970038, 0.970529,
    0.971021, 0.971512, 0.972003, 0.972494, 0.972985, 0.973476, 0.973968, 0.974459, 0.97495, 0.975441, 0.975932, 0.976424,
    0.976915, 0.977406, 0.977897, 0.978388, 0.978879, 0.979371, 0.979862, 0.980353, 0.980844, 0.981335, 0.981826, 0.982318,
    0.982809, 0.9833, 0.983791, 0.984282, 0.984774, 0.985265, 0.985756, 0.986247, 0.986738, 0.987229, 0.987721, 0.988212,
    0.988703, 0.989194, 0.989685, 0.990176, 0.990668, 0.991159, 0.99165, 0.992141, 0.992632, 0.993124, 0.993615, 0.994106,
    0.994597, 0.995088, 0.995579, 0.996071, 0.996562, 0.997053, 0.997544, 0.998035, 0.998526, 0.999018, 0.999509, 1
]

// xpitch电音速率配置
export const xpitchEmRateConfig = [1,0.908319,0.879126,0.857911,0.840637,0.825805,0.812667,0.800789,0.789893,0.779789,
    0.770339,0.761441,0.753018,0.745006,0.737357,0.730031,0.722992,0.716213,0.709670,0.703341,0.697210,0.691261,0.685480,
    0.679854,0.674374,0.669030,0.663812,0.658714,0.653728,0.648848,0.644068,0.639383,0.634788,0.630278,0.625850,0.621500,
    0.617224,0.613018,0.608880,0.604808,0.600797,0.596847,0.592954,0.589116,0.585331,0.581598,0.577915,0.574279,0.570689,
    0.567145,0.563643,0.560183,0.556764,0.553384,0.550043,0.546738,0.543469,0.540235,0.537035,0.533868,0.530733,0.527630,
    0.524556,0.521513,0.518498,0.515512,0.512553,0.509621,0.506715,0.503834,0.500979,0.498148,0.495341,0.492557,0.489797,
    0.487058,0.484341,0.481646,0.478972,0.476318,0.473684,0.471070,0.468476,0.465900,0.463343,0.460804,0.458283,0.455780,
    0.453294,0.450825,0.448372,0.445936,0.443516,0.441111,0.438722,0.436349,0.433990,0.431646,0.429316,0.427001,0.424700,
    0.422412,0.420138,0.417878,0.415630,0.413396,0.411174,0.408965,0.406769,0.404584,0.402411,0.400251,0.398102,0.395964,
    0.393838,0.391723,0.389619,0.387526,0.385444,0.383372,0.381311,0.379260,0.377219,0.375188,0.373167,0.371156,0.369155,
    0.367163,0.365180,0.363207,0.361243,0.359288,0.357342,0.355404,0.353476,0.351556,0.349645,0.347742,0.345847,0.343961,
    0.342083,0.340212,0.338350,0.336496,0.334649,0.332811,0.330979,0.329156,0.327339,0.325530,0.323729,0.321934,0.320147,
    0.318367,0.316594,0.314827,0.313068,0.311315,0.309569,0.307830,0.306097,0.304370,0.302650,0.300937,0.299230,0.297529,
    0.295834,0.294145,0.292463,0.290786,0.289115,0.287451,0.285792,0.284139,0.282491,0.280850,0.279214,0.277583,0.275958,
    0.274339,0.272725,0.271116,0.269513,0.267915,0.266322,0.264734,0.263152,0.261574,0.260002,0.258435,0.256873,0.255315,
    0.253763,0.252215,0.250672,0.249134,0.247601,0.246072,0.244549,0.243029,0.241514,0.240004,0.238499,0.236997,0.235501,
    0.234008,0.232520,0.231037,0.229557,0.228082,0.226611,0.225145,0.223682,0.222224,0.220770,0.219320,0.217874,0.216432,
    0.214994,0.213560,0.212129,0.210703,0.209281,0.207862,0.206447,0.205036,0.203629,0.202226,0.200826,0.199430,0.198038,
    0.196649,0.195264,0.193882,0.192504,0.191130,0.189759,0.188391,0.187027,0.185667,0.184310,0.182956,0.181606,0.180259,
    0.178915,0.177575,0.176238,0.174904,0.173573,0.172246,0.170922,0.169601,0.168283,0.166968,0.165657,0.164348,0.163043,
    0.161740,0.160441,0.159145,0.157852,0.156561,0.155274,0.153990,0.152708,0.151430,0.150154,0.148882,0.147612,0.146345,
    0.145080,0.143819,0.142560,0.141305,0.140052,0.138801,0.137554,0.136309,0.135067,0.133827,0.132591,0.131357,0.130125,
    0.128896,0.127670,0.126446,0.125225,0.124007,0.122791,0.121577,0.120366,0.119158,0.117952,0.116748,0.115547,0.114349,
    0.113153,0.111959,0.110768,0.109579,0.108393,0.107209,0.106027,0.104848,0.103671,0.102496,0.101323,0.100153,0.098986,
    0.097820,0.096657,0.095496,0.094337,0.093180,0.092026,0.090874,0.089724,0.088576,0.087431,0.086288,0.085146,0.084007,
    0.082870,0.081735,0.080603,0.079472,0.078344,0.077217,0.076093,0.074970,0.073850,0.072732,0.071616,0.070501,0.069389,
    0.068279,0.067171,0.066065,0.064960,0.063858,0.062758,0.061659,0.060563,0.059469,0.058376,0.057285,0.056196,0.055110,
    0.054025,0.052941,0.051860,0.050781,0.049703,0.048627,0.047553,0.046481,0.045411,0.044343,0.043276,0.042211,0.041148,
    0.040087,0.039027,0.037969,0.036913,0.035859,0.034806,0.033755,0.032706,0.031659,0.030613,0.029569,0.028527,0.027486,
    0.026447,0.025410,0.024374,0.023340,0.022308,0.021277,0.020248,0.019221,0.018195,0.017171,0.016148,0.015127,0.014108,
    0.013090,0.012074,0.011059,0.010046,0.009035,0.008025,0.007016,0.006009,0.005004,0.004000,0.002998,0.001997,0.000998,
    0,]
